// @ts-ignore
import type {
    Coords,
    Coordinates
} from '@/store/states/ICoordinatesState.interface';
// @ts-ignore
import mapStyle from '../components/customRouteMapTemplate/mapStyle.json';
import type {ICustomRoute} from "@/store/states/ICustomRouteState.interface";

export default class apiGoogleService {

    /**
     * How many custom points can be for one request
     * to calculate user's custom route
     */
    public static MAX_CUSTOM_ROUTE_POINTS: number = 25;
    public static COUNTRY_CENTER_COORDINATES_LT = {
        lat: 55.1735998,
        lng: 23.8948016
    };

    public static TRAVEL_MODE = 'DRIVING';

    public static renderOptions = {
        suppressMarkers: true,
        polylineOptions: {
            strokeColor: 'rgba(0, 41, 255, 0.7)',
            strokeWeight: 4
        }
    }

    static directionsRenderer() {
        return new (window as any).google.maps.DirectionsRenderer( this.renderOptions );
    }

    /**
     * @param center Object
     * @param mapId
     * @param zoom
     */
    static initMap(center: Coords, mapId = 'map', zoom = 7): object {
        return new (window as any).google.maps.Map(
            document.getElementById(mapId), {
                center: center,
                zoom: zoom,
                styles: mapStyle,
                disableDefaultUI: true,
            });
    }

    static deserializeLatLng(value: {lat: number, lng: number}): any {
        return new (window as any).google.maps.LatLng(value.lat, value.lng);
    }

    static deserializeRoute(response): object {
        response['request'] = {travelMode: this.TRAVEL_MODE};

        response.routes.forEach((route, i) => {
            let bounds = new (window as any).google.maps.LatLngBounds();

            let pointNorthEast = route.bounds?.northeast;
            let pointSouthWest = route.bounds?.southwest;

            if (! pointNorthEast && ! pointSouthWest) {
                pointNorthEast = {lat: route.bounds?.north, lng: route.bounds?.east};
                pointSouthWest = {lat: route.bounds?.south, lng: route.bounds?.west};
            }

            bounds.extend(this.deserializeLatLng(pointNorthEast));
            bounds.extend(this.deserializeLatLng(pointSouthWest));
            route.bounds = bounds;

            route.legs.forEach((leg) => {
                leg.start_location = this.deserializeLatLng(leg.start_location);
                leg.end_location = this.deserializeLatLng(leg.end_location);

                leg.steps.forEach((step) => {
                    step.start_location = this.deserializeLatLng(step.start_location);
                    step.end_location = this.deserializeLatLng(step.end_location);
                    step.path = new (window as any).google.maps.geometry.encoding.decodePath(step.polyline.points);
                });
            });
        });
        return response;
    }

    static displayMarkers(
        map: object,
        payload: Coordinates,
        icons: {origin: string, destination: string, waypoint: string},
        customRoutes: ICustomRoute[]
    ): void {

        const markerOrigin = {
            icon: icons.origin,
            coordinates: payload.origin
        };

        const markerDestination = {
            icon: icons.destination,
            coordinates: payload.destination
        };

        const markerWaypoints = payload.waypoints!.map(el => (
            {
                icon: icons.waypoint,
                coordinates: el!.location
            }
        ));

        const allMarkers = [markerOrigin, ...markerWaypoints, markerDestination];

        for (let i = 0; i < allMarkers.length; i++) {
            new (window as any).google.maps.Marker({
                position: allMarkers[i].coordinates,
                map,
                icon: {
                    url: allMarkers[i].icon,
                    labelOrigin: new (window as any).google.maps.Point(11, 50)
                },
                title: customRoutes[i].routePoint!.locality,
                label: {
                    text: customRoutes[i].arrivalTime,
                    className: 'map-marker-label-style',
                    color: 'white',
                    fontSize: '10px'
                },
                zIndex: 5,

            })

        }
    }

}